import * as uiAnalyticsConsumer from '@servicenow/ui-analytics-consumer';
import {types, timingMetricTypes} from './constants';
import applyInteractionId from './applyInteractionId';
import getInteractionId from './getInteractionId';
import setInteractionId from './setInteractionId';
import createInteractionId from './createInteractionId';
import createTraceId from './createTraceId';
import defineMetric from './defineMetric';
import mark from './mark';
import getMarks from './getMarks';
import {
	getCounters as getPerformanceCounters,
	clearCounters as clearPerfomanceCounters
} from './counters';
import clearMarks from './clearMarks';
import observe from './observe';
import getMetricTypes from './getMetricTypes';
import addMarkAugmenter from './addMarkAugmenter';
import {collectMetrics, enable as enableMetrics, isPerfMetricsEnabled} from './metrics';
import {logTimingMetrics} from './timingMetrics';

const {setConfigValue} = uiAnalyticsConsumer;
setConfigValue('enableCounter', true);
setConfigValue('enableHistogram', true);
setConfigValue('enableTrack', true);

globalThis.nowUiFrameworkMetrics = {
	applyInteractionId,
	getInteractionId,
	setInteractionId,
	createInteractionId,
	createTraceId,
	defineMetric,
	mark,
	clearMarks,
	getMarks,
	observe,
	types,
	getMetricTypes,
	addMarkAugmenter,
	getPerformanceCounters,
	clearPerfomanceCounters,
	collectMetrics,
	logTimingMetrics,
	isPerfMetricsEnabled,
	enableMetrics
};

export {
	applyInteractionId,
	getInteractionId,
	setInteractionId,
	createInteractionId,
	createTraceId,
	defineMetric,
	mark,
	clearMarks,
	getMarks,
	observe,
	types,
	timingMetricTypes,
	getMetricTypes,
	addMarkAugmenter,
	getPerformanceCounters,
	clearPerfomanceCounters,
	collectMetrics,
	logTimingMetrics,
	isPerfMetricsEnabled,
	enableMetrics
};
